import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { ListTable } from 'gnos-tables'
import cx from 'classnames'
import _ from 'lodash'

import Entity from '../../../../../../../../../../../components/TableCell/components/Entity'
import CustomDate from '../../../../../../../../../../../components/CustomDate'
import Flag from '../../../../../../../../../../../components/TableCell/components/Flag'
import NoData from '../../../../../../../../../components/Workspace/components/NoData'

import { LOCALE_PREFIX } from '../../constants'
import './style.scss'

@injectIntl
export default class Managers extends Component {
    static propTypes = {
        data: PropTypes.array,
        locked: PropTypes.bool,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
    }

    render() {
        const { id, data, locked, intl } = this.props

        if (locked) {
            return (
                <div className={'persons-managers-block'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.lockedTab` })} />
                </div>
            )
        }

        if (_.isEmpty(data)) {
            return (
                <div className={'persons-managers-block'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.noData` })} />
                </div>
            )
        }

        return (
            <div className={'persons-managers-block'}>
                <ListTable
                    id={`persons-managers-table-${id}`}
                    columnsDefinition={{
                        title: {
                            width: 250,
                            Cell: (value) => (
                                <span className={cx('title-cell', _.get(value, 'isNested') && 'historic')}>
                                    {_.get(value, 'text', null)}
                                </span>
                            ),
                        },
                        top: {
                            columns: [
                                {
                                    accessor: 'subject',
                                    Cell: (value) => (
                                        <div className={'persons-table-subject-parent'}>
                                            {_.get(value, 'value.countryIso') !== 'CZ' &&
                                                !_.isNil(_.get(value, 'value.countryIso')) && (
                                                    <Flag country={_.lowerCase(_.get(value, 'value.countryIso'))} />
                                                )}
                                            <Entity
                                                entity={_.get(value, 'value', null)}
                                                caution={_.get(value, 'value.indicators.caution', null)}
                                                inactive={_.get(value, 'value.inactive', null)}
                                                notice={_.get(value, 'value.indicators.notice', null)}
                                                risk={_.get(value, 'value.indicators.risk', null)}
                                                type={_.get(value, 'value.type', null)}
                                                value={_.get(value, 'value.name', null)}
                                                entId={_.get(value, 'value.id', null)}
                                            />
                                        </div>
                                    ),
                                },
                                {
                                    accessor: 'dateRange',
                                    Cell: (value) => (
                                        <span className={'persons-table-date-cell-parent'}>
                                            {_.get(value, 'value.startDate.value') && (
                                                <span className={'persons-table-date-cell'}>
                                                    <FormattedMessage id={'global.date.from'} />
                                                    <CustomDate
                                                        date={_.get(value, 'value.startDate.value', null)}
                                                        precision={_.get(value, 'value.startDate.precision', null)}
                                                    />
                                                </span>
                                            )}
                                            {_.get(value, 'value.endDate.value') && (
                                                <span className={'persons-table-date-cell'}>
                                                    <FormattedMessage id={'global.date.to'} />
                                                    <CustomDate
                                                        date={_.get(value, 'value.endDate.value', null)}
                                                        precision={_.get(value, 'value.endDate.precision', null)}
                                                    />
                                                </span>
                                            )}
                                        </span>
                                    ),
                                },
                            ],
                        },
                        nested: {
                            visibleRows: (value) => {
                                if (_.get(value, 'tables[0].nested', false)) {
                                    // If there is only one table and it's historical
                                    const tablesRowsLength = _.get(value, 'tables[0].rows', []).length

                                    if (tablesRowsLength > 10) return 10 // Only show 10 rows on first step

                                    return tablesRowsLength // If there is less than 10 rows, show all rows
                                }

                                return 0 // Hide table if there is multiple tables and the first one isn't historical
                            },
                            // eslint-disable-next-line no-confusing-arrow
                            expandText: (value) =>
                                !_.get(value, 'tables[0].nested', false)
                                    ? intl.formatMessage({ id: `${LOCALE_PREFIX}.history` })
                                    : intl.formatMessage({ id: 'global.controlExpand' }),
                            columns: [
                                {
                                    accessor: 'subject',
                                    Cell: (value) => (
                                        <div className={'persons-table-subject-parent historic'}>
                                            {_.get(value, 'value.countryIso') !== 'CZ' &&
                                                !_.isNil(_.get(value, 'value.countryIso')) && (
                                                    <Flag country={_.lowerCase(_.get(value, 'value.countryIso'))} />
                                                )}
                                            <Entity
                                                entity={_.get(value, 'value', null)}
                                                caution={_.get(value, 'value.indicators.caution', null)}
                                                inactive={_.get(value, 'value.inactive', null)}
                                                notice={_.get(value, 'value.indicators.notice', null)}
                                                risk={_.get(value, 'value.indicators.risk', null)}
                                                type={_.get(value, 'value.type', null)}
                                                value={_.get(value, 'value.name', null)}
                                                entId={_.get(value, 'value.id', null)}
                                            />
                                        </div>
                                    ),
                                },
                                {
                                    accessor: 'dateRange',
                                    Cell: (value) => (
                                        <span className={'persons-table-date-cell-parent historic'}>
                                            {_.get(value, 'value.startDate.value') && (
                                                <span className={'persons-table-date-cell'}>
                                                    <FormattedMessage id={'global.date.from'} />
                                                    <CustomDate
                                                        date={_.get(value, 'value.startDate.value', null)}
                                                        precision={_.get(value, 'value.startDate.precision', null)}
                                                    />
                                                </span>
                                            )}
                                            {_.get(value, 'value.endDate.value') && (
                                                <span className={'persons-table-date-cell'}>
                                                    <FormattedMessage id={'global.date.to'} />
                                                    <CustomDate
                                                        date={_.get(value, 'value.endDate.value', null)}
                                                        precision={_.get(value, 'value.endDate.precision', null)}
                                                    />
                                                </span>
                                            )}
                                        </span>
                                    ),
                                },
                            ],
                        },
                    }}
                    staticData={{
                        _table: data,
                    }}
                    texts={{
                        loading: intl.formatMessage({ id: 'global.loading' }),
                        noData: intl.formatMessage({ id: 'global.noData' }),
                        controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                        controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                        controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                        controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                        controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                        controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                    }}
                />
            </div>
        )
    }
}
